import { gql } from '@apollo/client';

/**
 * Staff proxy operations — staff-side facades over 6 customer-side ops on
 * open-api. The staff-api resolver resolves the target account from the
 * input device(s), enforces single-account, then forwards to open-api with
 * `Authorization: Bearer OPS_STAFF_API_BACKEND_TOKEN` + `X-Impersonate-Account-Id`
 * + `X-Impersonate-Team-Id`.
 *
 * IMPORTANT: signatures match staff-api inputs (see
 * apps/api/src/app/proxy/proxy.inputs.ts), NOT the customer-side ops. Staff
 * unstable-shape mutations accept a `payloadJson: String` instead of the
 * full input type, so staff-api isn't coupled to open-api enum churn. The
 * `MdmActionHandlers` dispatch wrapper does the JSON.stringify on the way
 * in and JSON.parse on the way back.
 */

// mdmCommand: dedicated input (deviceIds + command + value), returns Boolean.
export const STAFF_PROXY_MDM_COMMAND = gql`
  mutation StaffProxyMdmCommand($payload: MdmCommandInput!) {
    staffProxyMdmCommand(payload: $payload)
  }
`;

// toggleDeviceFeature: deviceIds + payloadJson, returns Boolean.
export const STAFF_PROXY_TOGGLE_DEVICE_FEATURE = gql`
  mutation StaffProxyToggleDeviceFeature($payload: StaffToggleDeviceFeatureInput!) {
    staffProxyToggleDeviceFeature(payload: $payload)
  }
`;

// addCommandExecution: teamId + payloadJson + isNeedResponse, returns JSON String.
export const STAFF_PROXY_ADD_COMMAND_EXECUTION = gql`
  mutation StaffProxyAddCommandExecution($payload: StaffAddCommandExecutionInput!) {
    staffProxyAddCommandExecution(payload: $payload)
  }
`;

// addCommandExecutionGroup: teamId + payloadJson, returns JSON String.
export const STAFF_PROXY_ADD_COMMAND_EXECUTION_GROUP = gql`
  mutation StaffProxyAddCommandExecutionGroup($payload: StaffAddCommandExecutionGroupInput!) {
    staffProxyAddCommandExecutionGroup(payload: $payload)
  }
`;

// platformApiCommand: deviceId + operation + argsJson, returns JSON String.
export const STAFF_PROXY_PLATFORM_API_COMMAND = gql`
  mutation StaffProxyPlatformApiCommand($payload: StaffPlatformApiCommandInput!) {
    staffProxyPlatformApiCommand(payload: $payload)
  }
`;

// getRemoteControlLink: teamId + deviceId, returns JSON String. QUERY, not mutation
// — staff-api side keeps it as a query because there's no state change.
export const STAFF_PROXY_GET_REMOTE_CONTROL_LINK = gql`
  query StaffProxyGetRemoteControlLink($payload: StaffGetRemoteControlLinkInput!) {
    staffProxyGetRemoteControlLink(payload: $payload)
  }
`;
